module.exports = __webpack_public_path__ + "dashboard/img/en.988c55965f0fc943d9e38ed9954dbd62.svg";